export class DeepCopy {
  static copy(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
}
